import { Outlet } from "react-router-dom";

import Sidebar from "@/components/navigation/Sidebar";
import Topbar from "@/components/navigation/Topbar";
import AuthProvider from "@/providers/auth/provider";
// import AuthProvider from "@/providers/auth/provider";
// import ConfirmDialogProvider from "@/providers/confirm-dialog/provider";


const AppLayout = () => {

    return (
         <AuthProvider>
            {/* <ConfirmDialogProvider>
                <div className="flex max-h-screen bg-white">
                    <section className="hidden md:block w-1/4 xl:w-1/5">
                        <Sidebar />
                    </section>

                    <section className="flex-1 pl-4 pr-6 py-4 overflow-y-auto">
                        <Outlet />
                    </section>
                </div>
            </ConfirmDialogProvider> */}
                <div className="flex max-h-screen bg-[#fbf9f7]">
                    <section className="hidden md:block w-1/4 xl:w-[18%]">
                        <Sidebar />
                    </section>

                    <section className="flex-1 bg-[#EDE8E4]/5 overflow-y-auto">
                        <Topbar />
                        <div className="">
                            <Outlet />
                        </div>
                    </section>
                </div>
        </AuthProvider>
    )
}

export default AppLayout